module.exports = __webpack_public_path__ + "img/Centro.479d2169.jpg";